import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from "@angular/router";
import locations from "../../../data/locations";

@Component({
  selector: 'app-locations-page',
  templateUrl: './locations-page.component.html',
  styleUrls: ['./locations-page.component.css']
})
export class LocationsPageComponent implements OnInit {

  constructor(public route: ActivatedRoute,) { }

  locations = locations;
  cities: any;
  state = "";
  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      if (params.has("state")) {
        this.state = params.get("state");
      }
    });

    for(var i = 0; i< this.locations.length; i++) {
      if(locations[i].state == this.state) {
        this.cities = locations[i].cities;
      }
    };




  }

}
